<template lang="pug">
v-form#paymentForm(ref="paymentForm", @submit.prevent="doSave", lazy-validation)
  v-container(grid-list-md)
    v-layout(wrap)
      v-flex(lg1, md1, xs12)
        v-text-field(
          dense,
          v-model="list.data.areaCode",
          v-numeric-only,
          label="Kode Area",
          required,
          :rules="[(v) => !!v || 'Masukan kode area']"
        )
      v-flex(lg2, md2, xs12)
        v-text-field(
          dense,
          v-model="list.customerId",
          v-numeric-only,
          label="No. Pelanggan",
          required,
          :rules="[(v) => !!v || 'Masukan no pelanggan']"
        )
      v-flex(lg5, md5, xs12)
        v-text-field(
          dense,
          v-model="list.description",
          label="Nama",
          required,
          :rules="[(v) => !!v || 'Masukan nama']"
        )
    .ma-2.menu-btn(justify-center, style="text-align: center")
      v-btn.mx-1(@click="doCancel") Kembali
        v-icon mdi-arrow-left
      v-btn.mx-1(
        color="btnprimary white--text",
        type="submit",
        form="paymentForm"
      ) Simpan
        v-icon mdi-content-save-outline
</template>
<script>
export default {
  name: "FPaymentPstnListForm",
  props: ["productId", "productGroup"],
  data() {
    return {
      list: {
        customerId: "",
        description: "",
        data: {
          areaCode: "",
        },
      },
    };
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doReset() {
      if (this.$refs.paymentForm) {
        this.$refs.paymentForm.resetValidation();
      }
      this.list = {
        customerId: "",
        description: "",
        data: {
          areaCode: "",
        },
      };
    },
    doSave() {
      if (this.$refs.paymentForm.validate()) {
        this.$emit("list", this.list);
        this.doReset();
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.doReset();
    },
  },
};
</script>